import Relay from 'react-relay';
import IsomorphicRelay from 'dibs-isomorphic-relay';
import SV from 'server-vars';
import networkLayer from '../global/relayClientNetworkLayer.es';

const relayEnvironmentProvider = () => {
    let environment = null;

    return {
        getEnvironment() {
            if (!environment) {
                environment = Relay.Store;
                environment.injectNetworkLayer(networkLayer());

                // Todo: Put SV key in const file or pass in data?
                const preLoadedData = SV.get('header.preLoadedData');

                if (preLoadedData) {
                    IsomorphicRelay.injectPreparedData(environment, preLoadedData);
                }
            }
            return environment;
        }
    };
};

const provider = relayEnvironmentProvider();
const { getEnvironment } = provider;

export { getEnvironment };
export default provider;




// WEBPACK FOOTER //
// ./assets/js/global/relayEnvironmnentProvider.es.js